import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3dee9cdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Te damos la bienvenida!", -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { useRoute } from 'vue-router';
import {onMounted, ref} from 'vue';
import { useAuth } from '@/store/useAuth';
import PayPalService from '@/services/PayPalService'
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProDevWelcomeView',
  setup(__props) {

const route = useRoute()
const subscriptionId = route.params.subscriptionId
const store = useAuth()
const feedback = ref('')
const paypalService = new PayPalService()

onMounted(async () => {
    if(!store.token) {
        feedback.value = "Acceso a página no permitido"
        return;
    }

    feedback.value = "Estamos registrando tu suscripción. Un momento, por favor..."
    const response = await paypalService.storeSub(store.token, subscriptionId)
    if(response.success) {
        feedback.value = "¡Todo listo! Ya puedes comenzar a aprender sin límites."
    }


})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_unref(main).WELCOME_MESSAGE), 1),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(feedback.value), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})